import { render, staticRenderFns } from "./ContentRight.vue?vue&type=template&id=6fa43acb"
import script from "./ContentRight.vue?vue&type=script&lang=js"
export * from "./ContentRight.vue?vue&type=script&lang=js"
import style0 from "./ContentRight.vue?vue&type=style&index=0&id=6fa43acb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports